import './modal-cancel-class.scss';

//react
import { useState, useRef, useEffect } from 'react';
import { useMutation } from '@apollo/client';
//shared
import Modal from '../modal-alert/modal-alert';
import { CREATE_CANCEL_CLASS, ADD_CLOSE_QUOTAS, CLASSES_BRANCH } from '../../graphql/branch';
import Message from '../message/message';
import { MESSAGE_ADD_QUOTAS } from '../../../class-branch/constants/messages';
//material
import { Button, TextField } from '@mui/material';
import Icon from '../icon/icon';
import { useParams } from 'react-router-dom';

export const ModalCancelClass = ({ calendarId, feeLate, availableSpace, reservations, lateCancel }: { calendarId: number, feeLate: number, availableSpace: number, reservations: number, lateCancel: boolean }) => {

  const { id }: any = useParams();

  let [estatusModal, changeStateModal] = useState(false);
  let [estatusModalHappened, changeStateModalHappened] = useState(false);
  let [estatusSubModal, changeStateSubModal] = useState(false);
  let [valueDescriptionHappened, setValueDescriptionHappened] = useState(String);

  const [ActiveQuotas, { data, loading, error, reset }] = useMutation(ADD_CLOSE_QUOTAS, {
    variables: {
      userId: null,
      calendarId: calendarId,
      close: true,
      quotas: availableSpace,
      requiresValidation: true
    },
    refetchQueries: [CLASSES_BRANCH]
  });
  let message = MESSAGE_ADD_QUOTAS;
  message.open = useRef<any>(null);

  if (data) {
    message.textMessage = data.AddAndCloseQuotas.message;
    message.style = data.AddAndCloseQuotas.success ? 'success' : 'danger';
    changeStateSubModal(!estatusSubModal);
    setTimeout(() => {
      message.open.current.show();
    }, 500);
    reset();
  }

  if (error) console.log(`Submission error! ${error.message}`);


  /* Section of support cancelation class */

  const [imagesHappened, setImagesHappened] = useState<any>([]);
  const [CancelClass] = useMutation(CREATE_CANCEL_CLASS, {
    variables: {
      userId: null,
      calendarId: calendarId,
      reasonCancelation: '',
      supports: [],
      studioId: parseInt(id)
    }
  });

  const handleImageChange = (event: any) => {
    setImagesHappened([]);
    const files: any = event.target.files;

    for (let i = 0; i < files.length; i++) {
      const reader = new FileReader();
      reader.onload = (e: any) =>
        setImagesHappened((imagesBaseSupport: any) => [...imagesBaseSupport, e.target.result]);
      reader.readAsDataURL(files[i]);
    }
  };

  const sendCancelClass = async () => {

    if (!valueDescriptionHappened) return;

    await CancelClass({
      variables: {
        userId: null,
        calendarId: calendarId,
        reasonCancelation: valueDescriptionHappened,
        supports: imagesHappened,
        studioId: parseInt(id)
      },
    }).then((data: any) => {

      if (data.data.cancelClass.success) {

        ActiveQuotas({
          variables: {
            userId: null,
            calendarId: calendarId,
            close: true,
            quotas: availableSpace,
            requiresValidation: true
          },
        });

        changeStateSubModal(true);
        changeStateModal(false);
        changeStateModalHappened(false);
      }

      message.textMessage = data.data.cancelClass.message;
      message.style = data.data.cancelClass.success ? 'success' : 'danger';
      setTimeout(() => {
        message.open.current.show();
        changeStateSubModal(false);
      }, 800);
    }
    ).catch((error) => {
      console.error(error)
    });

  }

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <div className="modal-cancel-class">
      {/* <CheckCircleIcon className='checkIcon' onClick={() => changeStateModal(!estatusModal)} /> */}

      <Button disabled={loading || !availableSpace} className={`btn-cancel-class ${windowWidth <= 860 ? ' btn-action-mobile' : ''}`} onClick={() => changeStateModal(!estatusModal)}>
        {windowWidth >= 861 && (<span>Cancelar clase</span>)}
        {windowWidth <= 860 && (<Icon width='20' height='19' name='trash'></Icon>)}
      </Button>

      <Modal
        estatus={estatusModal}
        changeStatus={estatusModal}
        showHeader={false}
        buttonCancel={false}
        classNameModal='class-modal-cancel-class'
      >
        <div className='content'>
          <div className="content-body">
            <Icon width='75' height='75' name='person-warning' color='#00195e'></Icon>

            {(reservations > 0 && lateCancel === true) && (
              <>
                <h3>¡Alto! recuerda que...</h3>
                <p>
                  Si cancelas 4 horas antes de la clase y/o ya tienes reseveras activas se te generará una multa de ${feeLate ? feeLate : 0}
                  <b> ¿Estas seguro que quieres cancelar la clase?</b>
                </p>
              </>
            )}

            {(!lateCancel || reservations === 0) && (
              <>
                <h3>¡Alto!</h3>
                <p>¿Estas seguro que quieres cancelar la clase?</p>
              </>
            )}

            <div className='buttons'>
              <Button className='ok-button' disabled={loading} onClick={() => {
                ActiveQuotas({
                  variables: {
                    userId: null,
                    calendarId: calendarId,
                    close: true,
                    quotas: availableSpace,
                    requiresValidation: true
                  },
                });

                changeStateModal(false);
                changeStateSubModal(true);
              }}>
                Si, quiero cancelarla
              </Button>

              <Button onClick={() => changeStateModal(!estatusModal)} className="cancel-button">No, mejor no</Button>
            </div>
          </div>
          {(reservations > 0 && lateCancel === true) && (
            <div className="footer-cancel-class">
              <small>
                ¿Cancelas la clase por un caso de fuerza mayor?
                <span className='ml-05' onClick={() => changeStateModalHappened(!estatusModalHappened)}>
                  Cuéntanos lo que pasó
                </span>
              </small>
            </div>
          )
          }
        </div>
      </Modal >

      <Modal estatus={estatusModalHappened}
        changeStatus={estatusModalHappened}
        showHeader={false}
        buttonCancel={false}
        classNameModal='class-modal-cancel-class-happened'>
        <div className='content'>
          <div className='content-header-happened'></div>
          <div className='content-body-happened'>
            <h4>Cuéntanos lo que pasó</h4>
            <p>
              Sabemos que pueden pasar muchas cosas a último minuto, ten presente que puede adjuntar soportes
              (si consideras que la situación lo amerita). Evaluaremos tu caso y te daremos una respuesta en el
              menor tiempo posible.
            </p>
            <div className='area-attach'>
              <TextField className='textarea-happened' required
                multiline color='secondary'
                sx={{ borderRadius: '12px', width: '100%', height: 'auto' }}
                value={valueDescriptionHappened}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                  setValueDescriptionHappened(event.target.value);
                }}
              />
              <div className='container-bottom-attach'>
                {imagesHappened && (
                  imagesHappened.map((el: any, index: number) => (
                    <a className='img-loaded' href={el} target='_blank' rel='noreferrer'>Foto {index + 1}</a>
                  ))
                )}
                <Button className='btn-attach-file' component='label'>
                  <Icon name='attach' width='10' height='10' color='#747474' />
                  <input type='file' hidden accept="image/*" multiple onChange={handleImageChange} id='button-file' />
                  <span className='ml-05'>Adjuntar</span>
                </Button>
              </div>
            </div>
            <div className='buttons mt-1'>
              <Button className='ok-button-happened' disabled={loading} onClick={() => { sendCancelClass() }}>
                Enviar
              </Button>
              <Button className='cancel-button-happened' onClick={() => {
                changeStateModalHappened(!estatusModalHappened);
                setImagesHappened([]);
                setValueDescriptionHappened('')
              }} >
                Cancelar
              </Button>
            </div>
          </div>
        </div>
      </Modal>

      <Modal estatus={estatusSubModal}
        changeStatus={estatusSubModal}
        showHeader={false}
        buttonCancel={false}>
        <h3>¡Listo!</h3>
        <p>Solicitud enviada</p>
      </Modal>

      <Message data={message} ref={message.open} />
    </div >
  )
}